import Vue from 'vue'
import axios from 'axios'
import config from './config'
import { dev } from './utils'

const axios_instance = axios.create({
  baseURL: dev ? '/api' : config.api_address,
  auth: { username: 'admin', password: '123456' },
})

axios_instance.interceptors.request.use(req => {
  window.$vm.$Progress.start()
  return req
})
axios_instance.interceptors.response.use(res => {
  window.$vm.$Progress.finish()
  return res.data
})

export const request = (config) => {
  let promise
  if (Array.isArray(config)) {
    promise = Promise.all(config.map(e => axios_instance.request(e)))
  } else {
    promise = axios_instance.request(config)
  }
  return promise
}

export const http = (config, next, error) => {
  let source = axios.CancelToken.source()
  if (Array.isArray(config)) {
    config = config.map(e => ({ ...e, cancelToken: source.token }))
  } else {
    config = { ...config, cancelToken: source.token }
  }

  request(config).then(next).catch(error)

  return () => source.cancel()
}

export const alertError = err => {
  if (err instanceof PromiseRejectionEvent) {
    err = err.reason
  }
  if (!err.request || axios.isCancel(err)) { return }


  window.$vm.$Progress.fail()

  if (err.response.status === 401) {
    alert('当前用户权限不足，请重新登录')
    Vue.router.push('/login?back')
    return
  }

  let { data } = err.response
  let code = `${err.response.status} ${err.response.statusText}`
  let message
  if (data === undefined) {
    message = code
  } else if (typeof data === 'object' || Array.isArray(data)) {
    if((typeof data === 'object')&&data.msg){
      message = `${code}\r\n${data.msg}`
    }else{
      message = `${code}\r\n${JSON.stringify(data, null, 2)}`
    }
  } else {
    message = `${code}\r\n${data}`
  }

  alert(message)

  if (err.response.status === 403) {
    Vue.router.replace('/')
    return
  }
}
